<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1">
                    <vue-tags-input
                        v-model="model"
                        :tags="tags"
                        :autocomplete-items="autocompleteItems"
                        @tags-changed="update"
                        data-lpignore="true"
                        :placeholder="'Add Tags...'"
                        :separators="[',']"
                        class="leading-none focus:outline-none focus:border-gray-600"/>
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "InputTags",
        props: ['label', 'value', 'name', 'readonly', 'rules', 'mask', 'required', 'type', 'tooltip', 'dollar'],
        data: function(){
            return {
                model: '',
                tags: [],
                autocompleteItems: [],
                debounce: null,
            }
        },
        watch: {
            'tag': 'initItems',
        },
        mounted() {
            if (this.value){
                this.tags = this.value;
            }
        },
        methods: {
            update(newTags) {
                this.autocompleteItems = [];
                this.tags = newTags;
                this.$emit('input', newTags);
            },
            initItems() {
                //if (this.tag.length < 2) return;

                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    axios.get(process.env.VUE_APP_API_URL + '/tags').then(response => {
                        this.autocompleteItems = response.data.results.map(a => {
                            return { text: a.name };
                        });
                    }).catch(() => console.warn('Oh. Something went wrong'));
                }, 600);
            },
        },
        computed: {
            filteredItems() {
                return this.autocompleteItems.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
    }
</script>

<style>
    .ti-tag {
        background-color: #3370A0!important;
        border-radius: 0!important;
        font-size: .8em!important;
    }

    .ti-tag .ti-actions {
        margin-left: 5px!important;
        margin-top: 2px!important;
    }
</style>
